import Vue from 'vue';
import VueRouter from 'vue-router';
import script from '@/router/script.js'
import user from '@/router/userCenter'
import AIInterlocutor from '@/router/AIInterlocutor'
import NovelTurnScript from '@/router/novelTurnScript'
import ContactUs from '@/router/contactUs'
import Classroom from '@/router/classroom'
import Hottc from '@/router/hottc'

import Home from '../pages/home.vue' //首页
import Novel from '../pages/novel.vue'  //小说列表 创建等
import Editor from '../pages/editor.vue' //编辑
import Novelgenerator from '../pages/novel_generator.vue' //小说生生成器
import NovelgeneratorTemplate from '../pages/novel_generator_template.vue' //小说生生成器模版
import Message from '../pages/message.vue' //消息动态
import Record from '../pages/record.vue' //历史记录
import Apart from '../pages/apart.vue' //小说拆书
import ApartUnpackManage from '../pages/apart_unpack_manage.vue' //小说拆书管理
import ChapterUpdate from '../pages/chapter_add.vue' //章节正文批量导入
import ApartLog from '../pages/apart_log.vue' //仿写记录
import LongNovel from '../pages/longNovel/novel_long.vue'//长篇小说页面
import LongNovelEdit from '../pages/longNovel/novel_long_edit.vue'//长篇小说编辑页面
import SeriesLong from '../pages/longNovel/series_long.vue'//长篇分卷大纲管理
import SeriesList from '../pages/longNovel/series_list.vue'//长篇分卷列表页面
import SeriesSuccess from '../pages/longNovel/series_success.vue'//长篇小说创建成功的页面
import SeriesInfo from '../pages/longNovel/series_list.vue'//长篇小说信息页面
import SeriesChapterEditor from '../pages/longNovel/chapter_long.vue'//长篇小说分卷大纲内容编辑页面
import SeriesChapterList from '../pages/longNovel/chapter_list.vue'//长篇小说章节列表
import SeriesChapterOutline from '../pages/longNovel/chapter_outline.vue'//长篇小说章节大纲
import SeriesChapterOutlineImport from '../pages/longNovel/chapter_outline_impor.vue'//长篇小说章节大纲导入
import SeriesOutlineImport from '../pages/longNovel/series_outline_impor.vue'//长篇小说章节大纲导入
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/novel',
    name: 'novel',
    component: Novel,
  },
  {
    path: '/editor',
    name: 'editor',
    component: Editor,
  },
  {
    path: '/novelgenerator',
    name: 'novelgenerator',
    component: Novelgenerator,
  },
  {
    path: '/novelgeneratorTemplate',
    name: 'novelgeneratorTemplate',
    component: NovelgeneratorTemplate,
  },
  {
    path: '/novel_apart',
    name: 'novel_apart',
    component: Apart,
  },
  {
    path: '/apart_log',
    name: 'apart_log',
    component: ApartLog,
  },
  {
    path: '/message',
    name: 'Message',
    component: Message,
  },
  // {
  //   path: '/apart',
  //   name: 'Apart',
  //   component: Apart,
  // },
  {
    path: '/apartUnpackManage',
    name: 'ApartUnpackManage',
    component: ApartUnpackManage,
  },
  {
    path: '/record',
    name: 'Record',
    component: Record,
  },
  {
    path: '/chapterUpdate',
    name: 'ChapterUpdate',
    component: ChapterUpdate,
  },
  //长篇的内容
  {
    path: '/longNovel',
    name: 'LongNovel',
    component: LongNovel,
  },
  {
    path: '/longNovelEdit',
    name: 'LongNovelEdit',
    component: LongNovelEdit,
  },
  {
    path: '/seriesEditor',
    name: 'seriesEditor',
    component: SeriesLong,
  },
  {
    path: '/seriesList',
    name: 'seriesList',
    component: SeriesList,
  },
  {
    path: '/seriesSuccess',
    name: 'seriesSuccess',
    component: SeriesSuccess,
  },
  {
    path: '/seriesInfo',
    name: 'seriesInfo',
    component: SeriesInfo,
  },
  {
    path: '/seriesChapterEditor',
    name: 'seriesChapterEditor',
    component: SeriesChapterEditor,
  },
  {
    path: '/chapterList',
    name: 'chapterList',
    component: SeriesChapterList,
  },
  {
    path: '/chapterOutline',
    name: 'chapterOutline',
    component: SeriesChapterOutline,
  },
  {
    path: '/chapterOutlineImport',
    name: 'chapterOutlineImport',
    component: SeriesChapterOutlineImport,
  },
  {
    path: '/seriesOutlineImport',
    name: 'seriesOutlineImport',
    component: SeriesOutlineImport,
  },
  ...script,
  ...AIInterlocutor,
  ...user,
  ...ContactUs,
  ...NovelTurnScript,
  ...Classroom,
  ...Hottc
];

const router = new VueRouter({
  mode: 'history', // 路由模式：hash/history（默认hash）
  routes
});
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router;
